import { StyledCard, Typography, type UdemyItem } from '@mcdougald/ui/src';
import Image from 'next/image';

import { AuroraSectionHeading } from '@/components/resume/section-heading';
import { UDEMY_COURSES } from '@/constants/data/udemy-courses';

const numberFormatter = Intl.NumberFormat('en', { notation: 'compact' });

const RenderUdemyCourse = ({ udemyCourse }: { udemyCourse: UdemyItem }) => {
  const { title, headline, rating, subscribers, image_240x135 } = udemyCourse;
  return (
    <StyledCard
      growOnHover
      bg={'default'}
      className={'m-2 w-11/12 flex flex-col bg-primary/10 pb-4'}
    >
      <div className={'flex flex-col'}>
        <Image src={image_240x135} alt={title} width={240} height={135} />
        {/*<AvatarFallback />*/}
        <Typography
          variant={'lg'}
          weight={700}
          className={'w-12/12 mt-2 leading-6'}
        >
          {title}
        </Typography>
      </div>
      {/*<Typography variant={'sm'} className={'w-11/12 py-1 self-center'}>*/}
      {/*  {headline}*/}
      {/*</Typography>*/}
      <div className={'flex justify-between mt-auto pt-2 w-12/12 self-center'}>
        <div>Rating: {rating}</div>
        {subscribers ? (
          <div>Subs: {numberFormatter.format(subscribers)}</div>
        ) : null}
      </div>
    </StyledCard>
  );
};

export const UdemyCourses = () => {
  return (
    <div className={'udemy-container container mx-auto flex flex-col gap-4'}>
      <AuroraSectionHeading className={'font-bold mx-auto'}>
        Courses & Certs
      </AuroraSectionHeading>
      <div
        className={
          'udemy-courses-container grid gap-4 md:grid-cols-4 justify-center max-h-[500px] overflow-auto'
          //   'udemy-courses-container flex flex-wrap justify-center max-h-[500px] overflow-auto'
        }
      >
        {UDEMY_COURSES.map((item: UdemyItem) => {
          return (
            <RenderUdemyCourse udemyCourse={item} key={`udemy-${item.id}`} />
          );
        })}
      </div>
      {/*<LearnMoreButton href={'/skills'} text={'See more skills'} />*/}
    </div>
  );
};
